import AboutImage from '../../assets/IMG_4163.jpg'
import CV from '../../assets/NOMENA_TAFITASOA_RESUME_DEC_2023.pdf'
import {HiDownload} from 'react-icons/hi'
import data from './data'
import Card from '../../components/Card'
import './about.css'

const About = () => {
  return (
    <section id="about" data-aos="fade-in">
        <div className="container about__container">
            <div className="about__left">
                <div className="about__portrait">
                    <img src={AboutImage} alt="About Image" />
                </div>
            </div>
            <div className="about__right">
                <h2>About Me</h2>
                <div className="about__cards">
                    {
                        data.map(item => (
                            <Card key={item.id} className="about__card">
                                <span className='about__card-icon'>{item.icon}</span>
                                <h5>{item.title}</h5>
                                <small>{item.desc}</small>
                            </Card>
                        ))
                    }
                </div>
                <p>
                Building projects for  my clients love have always been my passion. Being in the Django web development and DevOps Engineer for over 4 years and serving more than 10 happy Malagasy clients , I'm always motivated to do more! Currently , I'm a <strong>freelancer</strong> for these domains.
                </p>
                <p>
                Hi, my name is <strong>RANDRIAMAMPIANINA Nomena Tafitasoa </strong> from Fianarantsoa , Madagascar. I'm a <strong>DevOps engineer </strong> with a Master's degree in Computer Science from <strong>" Ecole Nationale d'Informatique "</strong> the greatest Computer Science University  of Madagascar. I can speak <strong>5 languages Malagasy, French</strong> and <strong>English</strong> fluently and I start for learning <strong>Spanish</strong> and <strong>German</strong>. My top priority is to get your business online the right way, giving you industry-standard web app and all the functionality you need to operate smoothly online with DevOps way. Get in touch today with the details of your project let's get started! Check out my resume below!
                </p>
                <a href={CV} download className='btn primary'>Download CV <HiDownload/></a>
            </div>
        </div>
    </section>
  )
}

export default About